import { IRefreshChart } from '../../../models/interfaces'

export const selectRefreshChart = ({
  refreshChart: refreshState,
}: {
  refreshChart: IRefreshChart
}) => refreshState.refreshChart
